import React, { FC } from 'react';
import { Title } from '../developers/page-components/Title';
import { Spinner } from '../Spinner';
import { toAbsoluteUrl } from '../../utils';
import { useIdentity } from '../../store/identyti/identity-context';
import { PIIComponent } from './PIIComponent';
import { usePaymentContext } from '../../store/payments/payments-context';

export const PaymentInstrument: FC = () => {
	const { paymentContextState: { paymentInstrumentData, paymentInstrumentDataLoading }} = usePaymentContext();
	const { identityState: { userData }} = useIdentity();
	const isHidden = userData?.isPiiMasked;
	console.log('paymentInstrumentData', paymentInstrumentData);

	const paymentInstrumentFields = [
		{
			name: 'Id',
			value: paymentInstrumentData?.id,
		},
		{
			name: 'Owner',
			value: paymentInstrumentData?.cardHolderName,
			isHidden
		},
		{
			name: 'Card',
			value: paymentInstrumentData?.cardNumberMasked,
		},
	];

	const getCardIcon = (cardNumber): JSX.Element => {
		const firstNumber = cardNumber[0];
		const getIconURL = (): string => {
			switch (firstNumber) {
				case '4': return '/media/icons/cc-visa.svg';
				case '5': return '/media/icons/cc-mastercard.svg';
				default: return '/media/icons/credit-card-regular.svg';
			}
		};
		return <img
			className="me-1"
			src={toAbsoluteUrl(getIconURL())}
			height={17}
			width={20}
			alt="icon"
		/>;
	};

	const getFieldValue = (name: string, value: string): JSX.Element => {
		switch (name) {
			case 'Card':
				return (
					<div>
						{getCardIcon(value)}
						{value}
					</div>
				);
			case 'Owner':
				return <PIIComponent
					value={value}
					isHidden={isHidden}
					type='name'
				/>;
			default: return <span>{value}</span>;
		}
	};

	const getField = (): JSX.Element[] => {
		if (!paymentInstrumentDataLoading && paymentInstrumentFields[0].value) {
			return paymentInstrumentFields.map(({ name, value }): JSX.Element => {

				return (
					<div className="mt-3" key={name}>
						<div className="fs-9 text-muted fw-bold">
							{name}
						</div>
						<div className="fs-6 ">
							{value ? getFieldValue(name, value) : '-'}
						</div>
					</div>
				);
			});
		}
	};
	return (
		<div className="card mb-6 mb-md-0" data-cy="payment-instrument-block">
			<div className="card-body">
				<Title title="Payment Instrument" additionalClass="fs-4 fw-bolder mb-2"/>
				{ paymentInstrumentDataLoading && <Spinner /> }
				{
					!paymentInstrumentDataLoading && !paymentInstrumentFields[0].value && (
							<div>Not found</div>
						)
				}
				{getField()}
			</div>
		</div>
	);
};
